export const REQUEST_CALL = "REQUEST_CALL";

export interface ModalState {
  data: any;
  open: boolean;
  loading?: boolean;
  type: "" | "REQUEST_CALL";
}
